import { type TenantEmailDomainData, type TenantEmailDomainDnsRecord } from "~/gql/graphqlBase.generated";

export type DnsRecordsLoadState = "empty" | "failed" | "records";

export const dnsRecordsLoadState = (
	dnsRecords: readonly TenantEmailDomainDnsRecord[] | null | undefined
): DnsRecordsLoadState => {
	if (dnsRecords === null || dnsRecords === undefined) return "failed";
	return dnsRecords.length === 0 ? "empty" : "records";
};

export const ownershipChallengeRecords = (
	domain: Pick<TenantEmailDomainData, "challengeTxtHost" | "challengeTxtRecord">
): TenantEmailDomainDnsRecord[] =>
	domain.challengeTxtHost && domain.challengeTxtRecord
		? [{ data: domain.challengeTxtRecord, host: domain.challengeTxtHost, type: "TXT", valid: false }]
		: [];

export const domainSectionCopy = {
	dnsRecordsExplanation:
		"Add these DNS records at your domain registrar to prove ownership. Once validated, addresses under this domain need no individual verification.",
	dnsRecordsFailed: "We couldn't load your DNS records — try again.",
	dnsRecordsNone: "No DNS records were returned for this domain."
};
